import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchDashboardData } from '../../services/api';
import '../../styles/output.css';
import '../../styles/index.css';

import { SideMenu, Header, TopMenu } from 'maxcu-shared-lib';
import menuItems from '../SideMenu/menuItems';


function Dashboard() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const [isCollapsed, setIsCollapsed] = useState(false);
  
  useEffect(() => {
    let isMounted = true;
    document.title = "Member Rewards Dashboard | MAX Credit Union";

    const getData = async () => {
      try {
        
        const result = await fetchDashboardData();
        // console.log('getData: ',result)
        setTimeout(() => {
          if (isMounted){
            setData(result);
          }
        },500);
        
      } catch (err) {
        if (isMounted){
          setError(err);
        }
      }
    };
    getData();

    const handleResize = () => {
      if (window.innerWidth < 600) {
        setIsCollapsed(true);
      } else {
        setIsCollapsed(false);
      }
    };

    handleResize(); // Set initial state

    window.addEventListener('resize', handleResize);
    
    return () => {
      isMounted=false;
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  
  const handleCopyCode = () => {
    if (data?.referral_code) {
      navigator.clipboard.writeText(data.referral_code)
        .then(() => {
          alert('Referral Code Copied!');
          // Or use a more modern notification approach:
          // setNotification('Referral Code Copied!');
        })
        .catch(err => {
          console.error('Failed to copy:', err);
        });
    }
  };
  const handleCopyLink = () => {
    if (data?.referral_code) {
      navigator.clipboard.writeText('mymax.com/referrals?id=' + data.referral_code + '&n=' + data.first_name)
        .then(() => {
          alert('Referral Link Copied!');
          // Or use a more modern notification approach:
          // setNotification('Referral Code Copied!');
        })
        .catch(err => {
          console.error('Failed to copy:', err);
        });
    }
  };

  if (error) return (
    <div>
      <Header name="Member Rewards" />
      <div>Loading Error: {error.message}</div>
    </div>
  )
  if (!data) return <div className='text-center'>Loading...</div>;
  
  return (
    <div style={{ display: 'flex' }}>
      <SideMenu menuItems={menuItems}/>
      <div style={{ flex: 1 }} className={`${isCollapsed ? 'sb-thin' : 'sb-wide'}`}>
      <Header name="Member Rewards" />
      {isCollapsed && <TopMenu />}
      <div className='sb-body'>
        {data.pts_available_count === 'NA' ? (
          <div>
            <header className="mb-8">
              <div className="sm:max-w-3xl mx-auto">
                <p className="text-left sm:text-center text-base sm:text-xl text-gray-700 mb-2 sm:mb-4">
                  You are not currently earning any points, but it's easy to get started. Open a checking account to be eligible to earn points. You can read more about how points work below.
                </p>
              </div>
            </header>
          </div>
        ) : data.pts_available_count === 'DOWN' ? (
          <div>
            <header className="mb-8"> 
              <div className="sm:max-w-3xl mx-auto">
                <p className="text-left sm:text-center text-base sm:text-xl text-gray-700 mb-2 sm:mb-4">
                  Cannot access your current points value. Please try back again later!
                </p>
              </div>
            </header>
          </div>
        ) : (
            <div>
              {/* BEGIN SECTION IF MEMBER HAS POINTS */}
              <section>
                <div className="mx-auto md:max-w-3xl md:grid md:grid-cols-3 md:gap-4">

                  <div className="items-center justify-center flex bg-emerald-100 p-6 rounded-md mb-2 sm:mb-4">
                    <div>
                      <p className="p-nomargin text-green-900 text-sm text-center">Currently earning</p>
                      <h2 className="text-dashboard-counts text-green-900 text-5xl text-center tracking-tighter">{ data.pts_earned_mtd }</h2>
                      <p className="p-nomargin text-green-900 text-sm text-center">points this month</p>
                      <div className="mt-4 text-center">
                        <button
                          onClick={() => navigate('/getpoints')}
                          className="mt-2 inline-block bg-blue-600 border border-transparent rounded-full py-1 px-6 text-sm font-bold text-white text-center hover:bg-blue-700">
                          Bonus Points
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="bg-blue-100 p-6 rounded-md mb-2 sm:mb-4">
                    <div>
                      <p className="p-nomargin text-blue-900 text-sm text-center">You currently have</p>
                      <h2 className="text-dashboard-counts text-blue-900 text-5xl text-center tracking-tighter">{ data.pts_available_count }</h2>
                      <p className="p-nomargin text-blue-900 text-sm text-center">points worth ${ data.pts_available_worth }</p>
                      
                      <div className="mt-6 text-center">
                      {data.memo_post_mode === 'YES' || data.redeem_off === 'YES' ? (
                        <div id="comeBack" className="text-redemption-off">Redemption Off. <br />Come back later.</div>
                      ) : (
                        parseFloat(data.pts_available_count.replace(/,/g, '')) >= 500 ? (
                          <button onClick={() => navigate('/redeem')} className="mt-2 inline-block bg-blue-600 border border-transparent rounded-full py-1 px-6 text-sm font-bold text-white text-center hover:bg-blue-700">
                            Redeem Points
                          </button>
                        ) : (
                          <div>Redeem at 500+ points</div>
                        )                   
                      )}

                      </div>
                    </div>
                  </div>

                  <div className="items-center justify-center flex bg-emerald-100 p-6 rounded-md mb-2 sm:mb-4">
                    <div>
                      <p className="p-nomargin text-emerald-900 text-sm text-center">You have redeemed</p>
                      <h2 className="text-dashboard-counts text-emerald-900 text-5xl text-center tracking-tighter">{ data.pts_redeemed_count }</h2>
                      <p className="p-nomargin text-emerald-900 text-sm text-center">points worth ${ data.pts_redeemed_worth }</p>
                    </div>
                  </div>
                </div>
              </section>
              </div>
        )}

        {data.pts_available_count !== 'DOWN' && (
                <div>
                  {/* END REFERRAL SECTION */}
                <section className="mb-8">
                <div className="mx-auto md:max-w-3xl md:grid md:grid-cols-2 md:gap-4">
                  <div className="bg-gray-50 p-6 rounded-md mb-2 sm:mb-4">
                    <div>
                      <h2 className="text-h2-referral text-2xl text-center tracking-tight leading-6 font-bold mb-4">Share the reward of membership. Refer a friend and get rewarded!</h2>
                      <p className="text-sm text-center"><strong>Referring is easy and starts here!</strong> Earn 5,000 points for both you and your friend. Copy the referral code and share, it's that easy.</p>
                      <div className="mt-6">
                        <a href="#morepoints" className="mt-2 inline-block w-full bg-transparent border border-transparent rounded-md py-2 text-sm font-bold text-blue-700 hover:text-blue-900 text-center">Learn More <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 inline-block" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7l5 5m0 0l-5 5m5-5H6" />
                        </svg></a>
                      </div> 
                    </div>
                  </div>
                  
                  <div className="bg-blue-100 p-6 rounded-md mb-2 sm:mb-4">
                    <div>
                      <p className="p-nomargin text-blue-900 text-sm text-center">Your referral code is</p>
                      <h2 id="displayCode" className="text-refcode text-blue-900 text-5xl text-center tracking-tighter font-bold">{ data.referral_code }</h2>
              
                      <div className="flex justify-center mb-6">
                      <button
                        onClick={handleCopyCode}
                        className="copy-button mt-2 inline-block w-1/2 bg-blue-600 border border-transparent rounded-full py-1 px-3 text-sm font-bold text-white text-center hover:bg-blue-700"
                      >
                        Copy Code
                      </button>
                      </div>
              
                      <p className="p-nomargin text-blue-900 text-sm text-center">Your referral link is</p>
                      <h2 id="displayLink" className="text-reflink text-blue-900 text-xl text-center tracking-tighter font-bold">mymax.com/referrals?id={ data.referral_code }&n={ data.first_name }</h2>
              
                      <div className="flex justify-center">
                        <button
                          onClick={handleCopyLink}
                          className="copy-button mt-2 inline-block w-1/2 bg-blue-600 border border-transparent rounded-full py-1 px-3 text-sm font-bold text-white text-center hover:bg-blue-700"
                        >
                          Copy Link
                        </button>

                      </div>
                    </div>
                  </div>
                  
                </div>
              </section>
                {/* END REFERRAL SECTION */}

                {data.pts_available_count === 'NA' ? (
                  <div>
                    {/* START SECTION - NOT EARNING POINTS - SHOWING OPTIONS */}
                  <section className="mb-8">
                  <div className="mx-auto sm:max-w-3xl sm:grid sm:grid-cols-2 sm:gap-4 mb-2 sm:mb-4">
                    <div>
                      <h2 className="text-h2-notransform text-xl font-bold leading-normal text-gray-800 mb-2">How to earn points</h2>
                      <p className="text-sm">Below is how to earn points, get started today!</p>

                      <nav className="mt-6">
                        <ol role="list" className="overflow-hidden">
                          
                          <li className="relative pb-6">
                            {/* vertical line --> */}
                            <div className="-ml-px absolute mt-0.5 top-4 left-4 w-0.5 h-full bg-gray-300" aria-hidden="true"></div>
                            
                            <div href="#" className="relative flex items-start group">
                              <span className="h-9 flex items-center" aria-hidden="true">
                                <span className="relative z-10 w-8 h-8 flex items-center justify-center bg-white border-2 border-gray-300 rounded-full">
                                  <span className="h-2.5 w-2.5 bg-transparent rounded-full"></span>
                                </span>
                              </span>

                              <dl className="ml-4 min-w-0 flex flex-col">
                                <dt className="text-xs font-bold tracking-wide uppercase text-blue-800">5 points for every swipe over $3</dt>
                                <dd className="text-sm text-gray-600">Sign up a checking account and earn every time you swipe your card.</dd>
                              </dl>
                            </div>
                          </li>
                      
                          <li className="relative pb-6">
                            {/* vertical line --> */}
                            <div className="-ml-px absolute mt-0.5 top-4 left-4 w-0.5 h-full bg-gray-300" aria-hidden="true"></div>
                            
                            <div href="#" className="relative flex items-start group">
                              <span className="h-9 flex items-center" aria-hidden="true">
                                <span className="relative z-10 w-8 h-8 flex items-center justify-center bg-white border-2 border-gray-300 rounded-full">
                                  <span className="h-2.5 w-2.5 bg-transparent rounded-full"></span>
                                </span>
                              </span>

                              <dl className="ml-4 min-w-0 flex flex-col">
                                <dt className="text-xs font-bold tracking-wide uppercase text-blue-800">25 points for each loan</dt>
                                <dd className="text-sm text-gray-600">For every loan you have at MAX, you earn <strong>25 points per month</strong> if you have a checking account.
                                </dd>
                              </dl>
                            </div>
                          </li>

                          <li className="relative pb-6">
                          {/* vertical line --> */}
                            <div className="-ml-px absolute mt-0.5 top-4 left-4 w-0.5 h-full bg-gray-300" aria-hidden="true"></div>
                            
                            <div className="relative flex items-start group">
                              <span className="h-9 flex items-center" aria-hidden="true">
                                <span className="relative z-10 w-8 h-8 flex items-center justify-center bg-white border-2 border-gray-300 rounded-full">
                                  <span className="h-2.5 w-2.5 bg-transparent rounded-full"></span>
                                </span>
                              </span>

                              <dl className="ml-4 min-w-0 flex flex-col">
                                <dt className="text-xs font-bold tracking-wide uppercase text-blue-800">Smart Rewards Credit Card</dt>
                                <dd className="text-sm text-gray-600">1 point for every $1 spent. 
                                  
                                </dd>
                              </dl>
                            </div>
                          </li>

                          <li className="relative pb-6">

                            <div className="-ml-px absolute mt-0.5 top-4 left-4 w-0.5 h-full bg-gray-300" aria-hidden="true"></div>
                            
                            <div href="#" className="relative flex items-start group">
                              <span className="h-9 flex items-center" aria-hidden="true">
                                <span className="relative z-10 w-8 h-8 flex items-center justify-center bg-white border-2 border-gray-300 rounded-full">
                                  <span className="h-2.5 w-2.5 bg-transparent rounded-full"></span>
                                </span>
                              </span>

                              <dl className="ml-4 min-w-0 flex flex-col">
                                <dt className="text-xs font-bold tracking-wide uppercase text-blue-800">10 points for Direct Deposit</dt>
                                <dd className="text-sm text-gray-600">Have direct deposit set up on a checking account and receive <strong>10 points per month</strong>.</dd>
                              </dl>
                            </div>
                          </li>
                      
                          <li className="relative pb-6">
                            {/* vertical line --> */}
                            <div className="-ml-px absolute mt-0.5 top-4 left-4 w-0.5 h-full bg-gray-300" aria-hidden="true"></div>
                            <div className="relative flex items-start group">
                              <span className="h-9 flex items-center" aria-hidden="true">
                                <span className="relative z-10 w-8 h-8 flex items-center justify-center bg-white border-2 border-gray-300 rounded-full">
                                  <span className="h-2.5 w-2.5 bg-transparent rounded-full"></span>
                                </span>
                              </span>

                              <dl className="ml-4 min-w-0 flex flex-col">
                                <dt className="text-xs font-bold tracking-wide uppercase text-blue-800">2500 points for every new loan</dt>
                                <dd className="text-sm text-gray-600">Fund a new loan and get a <strong>one-time 2500 point</strong> bonus. 
                                  
                                  <p>
                                    <a 
                                      href="https://lmsprod.mymax.com/Akcelerant.Origination.Web.DMZ/Default/Products/Index?ProductCategory=Borrow" 
                                      className="color-white btnApplyForLoan mt-2 inline-block w-auto bg-blue-600 border border-transparent rounded-full py-1 px-3 text-sm font-bold text-white text-center hover:bg-blue-700 hover:text-white"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      Apply Today
                                    </a>
                                  </p>
                                </dd>
                              </dl>
                            </div>
                          </li>

                          <li className="relative pb-6">
                          {/* vertical line --> */}
                            <div className="-ml-px absolute mt-0.5 top-4 left-4 w-0.5 h-full bg-gray-300" aria-hidden="true"></div>
                            
                            <div className="relative flex items-start group">
                              <span className="h-9 flex items-center" aria-hidden="true">
                                <span className="relative z-10 w-8 h-8 flex items-center justify-center bg-white border-2 border-gray-300 rounded-full">
                                  <span className="h-2.5 w-2.5 bg-transparent rounded-full"></span>
                                </span>
                              </span>

                              <dl className="ml-4 min-w-0 flex flex-col">
                                <dt className="text-xs font-bold tracking-wide uppercase text-blue-800">10 points for Loan AutoPay</dt>
                                <dd className="text-sm text-gray-600">Have AutoPay setup on at least one loan on your account and earn <strong>10 points per month</strong>. 
                                  
                                </dd>
                              </dl>
                            </div>
                          </li>

                          <li className="relative pb-6">
                            {/* vertical line --> */}
                            <div className="-ml-px absolute mt-0.5 top-4 left-4 w-0.5 h-full bg-gray-300" aria-hidden="true"></div>

                            <div className="relative flex items-start group">
                              <span className="h-9 flex items-center" aria-hidden="true">
                                <span className="relative z-10 w-8 h-8 flex items-center justify-center bg-white border-2 border-gray-300 rounded-full">
                                  <span className="h-2.5 w-2.5 bg-transparent rounded-full"></span>
                                </span>
                              </span>

                              <dl className="ml-4 min-w-0 flex flex-col">
                                <dt className="text-xs font-bold tracking-wide uppercase text-blue-800">5000 points for every new loan</dt>
                                <dd className="text-sm text-gray-600">For every member referral that meets qualifications after 60 days you receive a <strong>one-time 5,000 point</strong> bonus. 
                                </dd>
                              </dl>
                            </div>
                          </li>
                          <li className="relative pb-6">
                            
                            <div className="relative flex items-start group">
                              <span className="h-9 flex items-center" aria-hidden="true">
                                <span className="relative z-10 w-8 h-8 flex items-center justify-center bg-white border-2 border-gray-300 rounded-full">
                                  <span className="h-2.5 w-2.5 bg-transparent rounded-full"></span>
                                </span>
                              </span>

                              <dl className="ml-4 min-w-0 flex flex-col">
                                <dt className="text-xs font-bold tracking-wide uppercase text-blue-800">Youth: Earn points for academics</dt>
                                <dd className="text-sm text-gray-600">Earn <strong>300 points per A</strong> and <strong>200 points per B</strong> each grading period. Maximum of 2,500 points per year.
                                </dd>
                              </dl>
                            </div>
                          </li>

                        </ol>
                      </nav>

                    </div>

                  </div>
                  </section>
                  {/* END SECTION - NOT EARNING POINTS - SHOWING OPTIONS */}
                  </div>
                ) : (
                  <div className="mx-auto sm:max-w-3xl sm:grid sm:grid-cols-2 sm:gap-4 mb-2 sm:mb-4">
                      {/* START CURRENTLY EARNING SECTION */}
                      <div>
                        <div>
                          <h2 className="text-h2-currentearn text-xl font-bold leading-normal text-gray-800 mb-2">Your current points earnings</h2>
                          <p className="text-sm">Below is your anticipated earnings. Points for swipes are accrued nightly, other points are accrued at the end of the month. </p>

                        <nav className="mt-6">
                          <ol role="list" className="overflow-hidden">
                          {Object.entries(data.curr_pts_how)
                              //.filter(([_, itemData]) => itemData.yn === 'y') 
                              .map(([itemKey, itemData]) => (
                                itemData.type === 'spend' ? (
                                  <li className="relative pb-6">
                                    {/*} vertical line */}
                                    <div className="-ml-px absolute mt-0.5 top-4 left-4 w-0.5 h-full bg-gray-300" aria-hidden="true"></div>
                                  
                                  {itemData.yn === 'y' ? (
                                    <div href="#" className="relative flex items-start group">
                                      <span className="h-9 flex items-center">
                                        <span className="relative z-10 w-8 h-8 flex items-center justify-center bg-blue-600 rounded-full">
                                          <svg className="w-5 h-5 text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                          </svg>
                                        </span>
                                      </span>
                
                                      <dl className="ml-4 min-w-0 flex flex-col">
                                        <dt className="text-xs font-bold tracking-wide uppercase text-blue-800">5 points for every swipe over $3</dt>
                                        <dd className="text-sm text-gray-600">{itemData.desc} = <strong>{itemData.pts} points</strong></dd>
                                      </dl>
                                    </div>
                                  ) : (
                                    
                                    <div className="relative flex items-start group">
                                      <span className="h-9 flex items-center" aria-hidden="true">
                                        <span className="relative z-10 w-8 h-8 flex items-center justify-center bg-white border-2 border-gray-300 rounded-full">
                                          <span className="h-2.5 w-2.5 bg-transparent rounded-full"></span>
                                        </span>
                                      </span>
                
                                      <dl className="ml-4 min-w-0 flex flex-col">
                                        <dt className="text-xs font-bold tracking-wide uppercase text-blue-800">5 points for every swipe over $3</dt>
                                        <dd className="text-sm text-gray-600">Use your debit card and start earning today!</dd>
                                      </dl>
                                    </div>
                                  )}
                                  </li>
                

                                ) : itemData.type === 'dirdep' ? (
                                  <li className="relative pb-6">
                                  <div className="-ml-px absolute mt-0.5 top-4 left-4 w-0.5 h-full bg-gray-300" aria-hidden="true"></div>
              
                                  {itemData.yn === 'y' ? (
                                    <div href="#" className="relative flex items-start group">
                                      <span className="h-9 flex items-center">
                                        <span className="relative z-10 w-8 h-8 flex items-center justify-center bg-blue-600 rounded-full">
                                          <svg className="w-5 h-5 text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                          </svg>
                                        </span>
                                      </span>
                
                                      <dl className="ml-4 min-w-0 flex flex-col">
                                        <dt className="text-xs font-bold tracking-wide uppercase text-blue-800">10 points for having a direct deposit</dt>
                                        <dd className="text-sm text-gray-600">{itemData.desc} = <strong>{itemData.pts} points</strong></dd>
                                      </dl>
                                    </div>
                                  ) : (
                                    <div href="#" className="relative flex items-start group">
                                      <span className="h-9 flex items-center" aria-hidden="true">
                                        <span className="relative z-10 w-8 h-8 flex items-center justify-center bg-white border-2 border-gray-300 rounded-full">
                                          <span className="h-2.5 w-2.5 bg-transparent rounded-full"></span>
                                        </span>
                                      </span>
                
                                      <dl className="ml-4 min-w-0 flex flex-col">
                                        <dt className="text-xs font-bold tracking-wide uppercase text-blue-800">10 points for Direct Deposit</dt>
                                          <dd className="text-sm text-gray-600">Sign up for direct deposit and receive <strong>10 points per month</strong>.</dd>
                                        </dl>
                                    </div>
                                  )}
                                </li>

                                ) : itemData.type === 'youth' ? (
                                  <li className="relative pb-6">
                                  <div className="-ml-px absolute mt-0.5 top-4 left-4 w-0.5 h-full bg-gray-300" aria-hidden="true"></div>
              
                                  {itemData.yn === 'y' ? (
                                    <div href="#" className="relative flex items-start group">
                                      <span className="h-9 flex items-center">
                                        <span className="relative z-10 w-8 h-8 flex items-center justify-center bg-blue-600 rounded-full">
                                          <svg className="w-5 h-5 text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                          </svg>
                                        </span>
                                      </span>
                
                                      <dl className="ml-4 min-w-0 flex flex-col">
                                        <dt className="text-xs font-bold tracking-wide uppercase text-blue-800">{itemData.pts} points for academics</dt>
                                        <dd className="text-sm text-gray-600">{itemData.desc} = <strong>{itemData.pts} points</strong></dd>
                                      </dl>
                                    </div>
                                  ) : (
                                    <div href="#" className="relative flex items-start group">
                                      <span className="h-9 flex items-center" aria-hidden="true">
                                        <span className="relative z-10 w-8 h-8 flex items-center justify-center bg-white border-2 border-gray-300 rounded-full">
                                          <span className="h-2.5 w-2.5 bg-transparent rounded-full"></span>
                                        </span>
                                      </span>
                
                                      <dl className="ml-4 min-w-0 flex flex-col">
                                        <dt className="text-xs font-bold tracking-wide uppercase text-blue-800">Youth: Earn Points for Academics</dt>
                                          <dd className="text-sm text-gray-600">Earn 300 points per A and 200 points per B each grading period. Maximum of 2,500 points per year.</dd>
                                        </dl>
                                    </div>
                                  )}
                                </li>

                                ) : itemData.type === 'loan' ? (
                                  <li className="relative pb-6">
                                    {/* vertical line */}
                                    <div className="-ml-px absolute mt-0.5 top-4 left-4 w-0.5 h-full bg-gray-300" aria-hidden="true"></div>
                                    
                                    {itemData.yn === 'y' ? (
                                    <div className="relative flex items-start group">
                                      <span className="h-9 flex items-center">
                                        <span className="relative z-10 w-8 h-8 flex items-center justify-center bg-blue-600 rounded-full">
                                          <svg className="w-5 h-5 text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                          </svg>
                                        </span>
                                      </span>

                                      <dl className="ml-4 min-w-0 flex flex-col">
                                        <dt className="text-xs font-bold tracking-wide uppercase text-blue-800">25 points for each loan</dt>
                                        {Object.entries(itemData.desc)
                                          .map(([subItemKey, subItemData]) => (
                                            <dd key={subItemKey} className="text-sm text-gray-600">{subItemData.loan} = <strong>{subItemData.ptsper} points</strong></dd>
                                          ))}
                                      </dl>
                                    </div>
                                  ) : (
                                    <div className="relative flex items-start group">
                                      <span className="h-9 flex items-center" aria-hidden="true">
                                        <span className="relative z-10 w-8 h-8 flex items-center justify-center bg-white border-2 border-gray-300 rounded-full">
                                          <span className="h-2.5 w-2.5 bg-transparent rounded-full"></span>
                                        </span>
                                      </span>

                                      <dl className="ml-4 min-w-0 flex flex-col">
                                        <dt className="text-xs font-bold tracking-wide uppercase text-blue-800">25 points for each open and non delinquent loan</dt>
                                        <dd className="text-sm text-gray-600">Get an additional <strong>25 points</strong> per each open and non delinquent loan when you have a checking account. 
                                          
                                        </dd>
                                      </dl>
                                    </div>
                                  )}
                                  </li>
                                ) : itemData.type === 'ccrewards' ? (
                                  <li className="relative pb-6">
                                  {/* vertical line */}
                                    <div className="-ml-px absolute mt-0.5 top-4 left-4 w-0.5 h-full bg-gray-300" aria-hidden="true"></div>
                                  
                                  {itemData.yn === 'y' ? (
                                    <div className="relative flex items-start group">
                                      <span className="h-9 flex items-center">
                                        <span className="relative z-10 w-8 h-8 flex items-center justify-center bg-blue-600 rounded-full">
                                          <svg className="w-5 h-5 text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                          </svg>
                                        </span>
                                      </span>
                
                                      <dl className="ml-4 min-w-0 flex flex-col">
                                        <dt className="text-xs font-bold tracking-wide uppercase text-blue-800">1 point per $1 Smart Rewards</dt>
                                        <dd className="text-sm text-gray-600">{itemData.desc} = <strong>{itemData.pts} points</strong></dd>
                                      </dl>
                                    </div>
                                  ) : (
                                    <div className="relative flex items-start group">
                                      <span className="h-9 flex items-center" aria-hidden="true">
                                        <span className="relative z-10 w-8 h-8 flex items-center justify-center bg-white border-2 border-gray-300 rounded-full">
                                          <span className="h-2.5 w-2.5 bg-transparent rounded-full"></span>
                                        </span>
                                      </span>
                
                                      <dl className="ml-4 min-w-0 flex flex-col">
                                        <dt className="text-xs font-bold tracking-wide uppercase text-blue-800">1 point per $1 Smart Rewards</dt>
                                        <dd className="text-sm text-gray-600">Earn <strong>1 point</strong> for every $1 spent with a Smart Rewards Credit Card. 
                                          
                                        </dd>
                                      </dl>
                                    </div>
                                  )}
                                  </li> 
                
                                ) : itemData.type === 'autopay' ? (
                                  <li className="relative pb-6">
                                  {/* vertical line */}
                                    <div className="-ml-px absolute mt-0.5 top-4 left-4 w-0.5 h-full bg-gray-300" aria-hidden="true"></div>
                                  
                                    {itemData.yn === 'y' ? (
                                      <div className="relative flex items-start group">
                                        <span claclassNamess="h-9 flex items-center">
                                          <span className="relative z-10 w-8 h-8 flex items-center justify-center bg-blue-600 rounded-full">
                                            <svg className="w-5 h-5 text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                              <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                            </svg>
                                          </span>
                                        </span>
                  
                                        <dl className="ml-4 min-w-0 flex flex-col">
                                          <dt className="text-xs font-bold tracking-wide uppercase text-blue-800">10 points for Loan AutoPay</dt>
                                          <dd className="text-sm text-gray-600">{itemData.desc} = <strong>{itemData.pts} points</strong></dd>
                                        </dl>
                                      </div>
                                    ) : (
                                      <div className="relative flex items-start group">
                                        <span className="h-9 flex items-center" aria-hidden="true">
                                          <span className="relative z-10 w-8 h-8 flex items-center justify-center bg-white border-2 border-gray-300 rounded-full">
                                            <span className="h-2.5 w-2.5 bg-transparent rounded-full"></span>
                                          </span>
                                        </span>
                  
                                        <dl className="ml-4 min-w-0 flex flex-col">
                                          <dt className="text-xs font-bold tracking-wide uppercase text-blue-800">10 points for Loan AutoPay</dt>
                                          <dd className="text-sm text-gray-600">Get an additional <strong>10 points</strong> setting up one of your loans on Autopay. 
                                            
                                          </dd>
                                        </dl>
                                      </div>
                                    )}
                                  </li> 
                                ) : itemData.type === 'birthday' ? (
                                  itemData.yn === 'y' && (
                                  <li className="relative pb-6">
                                  {/* vertical line */}
                                  <div className="-ml-px absolute mt-0.5 top-4 left-4 w-0.5 h-full bg-gray-300" aria-hidden="true"></div>
                                      
                                    <div className="relative flex items-start group">
                                      <span className="h-9 flex items-center">
                                        <span className="relative z-10 w-8 h-8 flex items-center justify-center bg-blue-600 rounded-full">
                                          <svg className="w-5 h-5 text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                          </svg>
                                        </span>
                                      </span>

                                      <dl className="ml-4 min-w-0 flex flex-col">
                                        <dt className="text-xs font-bold tracking-wide uppercase text-blue-800">100 points for a Birthday this month</dt>
                                        <dd className="text-sm text-gray-600">{itemData.desc} = <strong>{itemData.pts} points</strong></dd>
                                      </dl>
                                    </div>
                                    
                                  </li> 
                                  )
                                ) : itemData.type === 'anniversary' ? (
                                  itemData.yn === 'y' && (
                                  <li className="relative pb-6">
                                  {/* vertical line */}
                                    <div className="-ml-px absolute mt-0.5 top-4 left-4 w-0.5 h-full bg-gray-300" aria-hidden="true"></div>
                                    
                                    <div className="relative flex items-start group">
                                      <span className="h-9 flex items-center">
                                        <span className="relative z-10 w-8 h-8 flex items-center justify-center bg-blue-600 rounded-full">
                                          <svg className="w-5 h-5 text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                          </svg>
                                        </span>
                                      </span>

                                      <dl className="ml-4 min-w-0 flex flex-col">
                                        <dt className="text-xs font-bold tracking-wide uppercase text-blue-800">100 points for your Checking Account Anniversary</dt>
                                        <dd className="text-sm text-gray-600">{itemData.desc} = <strong>{itemData.pts} points</strong></dd>
                                      </dl>
                                    </div>
                                    
                                  </li> 
                                  )

                                ) : itemData.type === 'referral_complete' ? (
                                  <li className="relative pb-6">
                                    {/*} vertical line */}
                                      <div className="-ml-px absolute mt-0.5 top-4 left-4 w-0.5 h-full bg-gray-300" aria-hidden="true"></div>
                                      

                                      <div className="relative flex items-start group">
                                        <span className="h-9 flex items-center">
                                          <span className="relative z-10 w-8 h-8 flex items-center justify-center bg-blue-600 rounded-full">
                                            <svg className="w-5 h-5 text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                              <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                            </svg>
                                          </span>
                                        </span>

                                        <dl className="ml-4 min-w-0 flex flex-col">
                                          <dt className="text-xs font-bold tracking-wide uppercase text-blue-800">{itemData.pts} pts for Referral</dt>
                                          <dd className="text-sm text-gray-600">{itemData.desc} = <strong>{itemData.pts} points</strong></dd>
                                        </dl>
                                      </div>
                                    </li> 

                                ) : itemData.type === 'newloan' ? (
                                  <li className="relative pb-6">
                                    {/*} vertical line */}
                                      <div className="-ml-px absolute mt-0.5 top-4 left-4 w-0.5 h-full bg-gray-300" aria-hidden="true"></div>
                                    
                                    {itemData.yn === 'y' ? (
                                      <div className="relative flex items-start group">
                                        <span className="h-9 flex items-center">
                                          <span className="relative z-10 w-8 h-8 flex items-center justify-center bg-blue-600 rounded-full">
                                            <svg className="w-5 h-5 text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                              <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                            </svg>
                                          </span>
                                        </span>
                  
                                        <dl className="ml-4 min-w-0 flex flex-col">
                                          <dt className="text-xs font-bold tracking-wide uppercase text-blue-800">2,500 points for each new loan in the month</dt>
                                          {Object.entries(itemData.desc)
                                          .map(([subItemKey, subItemData]) => (
                                            <dd key="subItemKey" className="text-sm text-gray-600">{subItemData.loan} = <strong>{subItemData.ptsper} points</strong></dd>
                                          ))}
                                          
                                        </dl>
                                      </div>
                                    ) : (
                                      <div className="relative flex items-start group">
                                        <span className="h-9 flex items-center" aria-hidden="true">
                                          <span className="relative z-10 w-8 h-8 flex items-center justify-center bg-white border-2 border-gray-300 rounded-full">
                                            <span className="h-2.5 w-2.5 bg-transparent rounded-full"></span>
                                          </span>
                                        </span>
                  
                                        <dl className="ml-4 min-w-0 flex flex-col">
                                          <dt className="text-xs font-bold tracking-wide uppercase text-blue-800">2,500 points for every new loan</dt>
                                          <dd className="text-sm text-gray-600">Fund a new loan and get a <strong>one-time 2,500 point</strong> bonus. 
                                            
                                            <p>
                                              <a 
                                                href="https://lmsprod.mymax.com/Akcelerant.Origination.Web.DMZ/Default/Products/Index?ProductCategory=Borrow" 
                                                className="color-white btnApplyForLoan mt-2 inline-block w-auto bg-blue-600 border border-transparent rounded-full py-1 px-3 text-sm font-bold text-white text-center hover:bg-blue-700 hover:text-white"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                              >
                                                Apply Today
                                              </a>
                                            </p>
                                          </dd>
                                        </dl>
                                      </div>
                                    )}
                                  </li>

                                ) : itemData.type === 'reportcard' ? (
                                  <li className="relative pb-6">
                                    
                                    {itemData.yn === 'y' ? (
                                      <div className="relative flex items-start group">
                                        <span className="h-9 flex items-center">
                                          <span className="relative z-10 w-8 h-8 flex items-center justify-center bg-blue-600 rounded-full">
                                            <svg className="w-5 h-5 text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                              <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                            </svg>
                                          </span>
                                        </span>
                  
                                        <dl className="ml-4 min-w-0 flex flex-col">
                                          <dt className="text-xs font-bold tracking-wide uppercase text-blue-800">Youth: Earn points for academics</dt>
                                          <dd className="text-sm text-gray-600"><strong>{itemData.pts} points</strong> for {itemData.desc}</dd>
                                        </dl>
                                      </div>
                                    ) : (
                                      <div className="relative flex items-start group">
                                        <span className="h-9 flex items-center" aria-hidden="true">
                                          <span className="relative z-10 w-8 h-8 flex items-center justify-center bg-white border-2 border-gray-300 rounded-full">
                                            <span className="h-2.5 w-2.5 bg-transparent rounded-full"></span>
                                          </span>
                                        </span>
                  
                                        <dl className="ml-4 min-w-0 flex flex-col">
                                          <dt className="text-xs font-bold tracking-wide uppercase text-blue-800">Youth: Earn points for academics</dt>
                                          <dd className="text-sm text-gray-600">Earn <strong>300 points per A</strong> and <strong>200 points per B</strong> each grading period. Maximum of 2,500 points per year.
                                          </dd>
                                        </dl>
                                      </div>
                                    )}
                                  </li>

                                  ) : itemData.type === 'mortgage' ? (
                                    <li className="relative pb-6">
                                    {/*} vertical line */}
                                      <div className="-ml-px absolute mt-0.5 top-4 left-4 w-0.5 h-full bg-gray-300" aria-hidden="true"></div>
                                    {itemData.yn === 'y' ? (
                                      <div className="relative flex items-start group">
                                        <span className="h-9 flex items-center">
                                          <span className="relative z-10 w-8 h-8 flex items-center justify-center bg-blue-600 rounded-full">
                                            <svg className="w-5 h-5 text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                              <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                            </svg>
                                          </span>
                                        </span>

                                        <dl className="ml-4 min-w-0 flex flex-col">
                                          <dt className="text-xs font-bold tracking-wide uppercase text-blue-800">1 point per $1,000 for each Mortgage Loan</dt>
                                          {Object.entries(itemData.desc)
                                            .map(([subItemKey, subItemData]) => (
                                              <dd className="text-sm text-gray-600">{subItemData.loan} = <strong>{subItemData.ptsper} points</strong></dd>
                                          ))}
                                        </dl>
                                      </div> 
                                    ) : (
                                      <div className="relative flex items-start group">
                                        <span className="h-9 flex items-center" aria-hidden="true">
                                          <span className="relative z-10 w-8 h-8 flex items-center justify-center bg-white border-2 border-gray-300 rounded-full">
                                            <span className="h-2.5 w-2.5 bg-transparent rounded-full"></span>
                                          </span>
                                        </span>

                                        <dl className="ml-4 min-w-0 flex flex-col">
                                          <dt className="text-xs font-bold tracking-wide uppercase text-blue-800">1 point per $1,000 for each Mortgage Loan</dt>
                                          <dd className="text-sm text-gray-600">Get 1 point per $1,000 for each open and non delinquent mortgage loan when you also have a checking account. 
                                            
                                          </dd>
                                        </dl>
                                      </div> 
                                    )}
                                    </li> 
                                ) : (
                                  <span>
                                    &nbsp;
                                  </span>
                                )

                             
                            ))}
                          </ol>
                        </nav>
                        </div>
                      </div>

                    {/* END CURRENTLY EARNING SECTION */}

                    {/* START REWARDS FEED SECTION */}

                    <div>
                        <h2 className="text-h2-feed text-xl font-bold leading-normal text-gray-800 mb-2">Rewards Feed</h2>
                        <p className="text-sm">The rewards feed shows a monthly summary of points earned, redemptions, and referral points earned. </p>
                        <div className="flow-root mt-6">
                        { data.rewards_feed ? (
                            <ul role="list" className="-mb-8">
                              {Object.entries(data.rewards_feed)
                                  .slice(0, 8)
                                  .map(([itemKey, itemData], index, array) => (
                                    <li key={itemKey} className="w-full">
                                      {itemData.type === 'earned' ? (
                                        <div className="relative pb-8 bg-emerald-100 rounded-md p-4 mb-2">
                                        <div className="relative flex space-x-3">
                                                <div className="pt-1.5">
                                                  <div>
                                                    <p className="p-feed-details color-white text-gray-600"><strong>You earned <strong className="text-green-600">+{itemData.points} points</strong> in {itemData.description}</strong>
                                                    <br /><br />
                                                    {Object.entries(itemData.details)
                                                      .map(([subItemKey, subItemData]) => (
                                                        <span>
                                                        <small>{subItemData.line } </small><br />
                                                        </span>
                                                      ))}
                                                    </p>
                                                  </div>
                                                </div>
                                          </div>
                                        </div>

                                      ) : itemData.type === 'adhoc' ? (
                                      <div className="relative pb-8 bg-green-100 rounded-md p-4 mb-2">
                                        <div className="relative flex space-x-3">
                                                <div className="pt-1.5">
                                                  <div>
                                                    <p className="p-feed-details color-white text-sm text-gray-600"><strong>You earned <strong className="text-green-600">+{itemData.points} points</strong> {itemData.description}</strong>
                                                    <br />
                                                    {Object.entries(itemData.details)
                                                      .map(([subItemKey, subItemData]) => (
                                                        <span className='span-feed-details'>
                                                        <small>{subItemData.line } </small><br />
                                                        </span>
                                                      ))}
                                                    </p>
                                                  </div>
                                                </div>
                                          </div>
                                        </div>
                                      ) : itemData.type === 'donate' ? (
                                        <div className="relative pb-8 bg-gray-100 rounded-md p-4 mb-2">
                                          <div className="relative flex space-x-3">
                                                  <div className="pt-1.5">
                                                    <div>
                                                      <p className="p-feed-details color-white text-sm text-gray-600"><strong>You donated <strong className="text-blue-600">+{itemData.points} points</strong> to {itemData.description}</strong>
                        
                                                      </p>
                                                    </div>
                                                  </div>
                                            </div>
                                          </div>
                                      )  : itemData.type === 'redeem' ? (
                                        <div className="relative pb-8 bg-blue-100 rounded-md p-4 mb-2">
                                          <div className="relative flex space-x-3">
                                                  <div className="pt-1.5">
                                                    <div>
                                                      <p className="color-white text-sm text-gray-600"><strong>You redeemed <strong className="text-blue-600">-{itemData.points} points</strong> for {itemData.description} on {itemData.date}</strong>
                                                      </p>
                                                    </div>
                                                  </div>
                                            </div>
                                          </div>
                                        )  : itemData.type === 'reportcard' ? (
                                        <div className="relative pb-8 bg-green-100 rounded-md p-4 mb-2">
                                          <div className="relative flex space-x-3">
                                                  <div className="pt-1.5">
                                                    <div>
                                                      <p className="color-white text-sm text-gray-600"><strong>You earned <strong className="text-green-600">+{itemData.points} points</strong> for {itemData.description} on {itemData.date}</strong>
                                                      </p>
                                                    </div>
                                                  </div>
                                            </div>
                                          </div>
                                        )  : itemData.type === 'referral' ? (
                                          <div className="relative pb-8 bg-gray-100 rounded-md p-4 mb-2">
                                            <div className="relative flex space-x-3">
                                                    <div className="pt-1.5">
                                                      <div>
                                                        <p className="color-white text-sm text-gray-600">You referred {itemData.description}
                                                        </p>
                                                      </div>
                                                    </div>
                                              </div>
                                            </div>
                                        )  : itemData.type === 'referral_complete' ? (
                                          <div className="relative pb-8 bg-gray-100 rounded-md p-4 mb-2">
                                            <div className="relative flex space-x-3">
                                                    <div className="pt-1.5">
                                                      <div>
                                                        <p className="color-white text-sm text-gray-600">You and {itemData.description} both earned <strong className="text-green-600">+{itemData.points} points</strong>
                                                        </p>
                                                      </div>
                                                    </div>
                                              </div>
                                            </div>

                                        ) : itemData.type === 'promo' ? (
                                          <div className="relative pb-8 bg-green-100 rounded-md p-4 mb-2">
                                            <div className="relative flex space-x-3">
                                                    <div className="pt-1.5">
                                                      <div>
                                                        <p className="p-feed-details color-white text-sm text-gray-600"><strong>You earned <strong className="text-green-600">+{itemData.points} points</strong> for {itemData.description} code</strong></p>
                                                      </div>
                                                    </div>
                                              </div>
                                            </div>

                                        ) : (
                                        <span>&nbsp;</span>
                                      )}

                                    </li>
                                  ))}
                              {/* hide the View More button for now                              
                                <li className="w-full text-center">
                                <button onClick={() => navigate('/rewardsfeed')} className="mt-2 inline-block w-1/2 bg-blue-600 border border-transparent rounded-full py-1 px-3 text-sm font-bold text-white text-center hover:bg-blue-700">
                                  View More
                                </button>
                                </li> */}
                            </ul>
                        ) : (
                          <p className="text-sm"><i>Points are added at the end of each month.<br />Check back again soon.</i></p>

                        )}

                        </div>
                    </div>              
                    {/* END REWARDS FEED SECTION */}

                  </div>
                )}
              </div>
              )}


                <div className="mx-auto sm:max-w-3xl how-padding">
                  <h2 className="text-h2-notransform text-xl font-bold leading-normal text-gray-800 mb-2">How it works</h2>
                  <p className="text-sm mb-4 text-gray-600">For every swipe over $3, you get 5 points. You earn bonus points by completing certain actions. See how you can earn more.</p>

                  <h3 className="text-base font-bold leading-normal text-gray-800 mb-2">How to earn points</h3>
                  <ul className="list-disc ml-4 text-sm mb-4 text-gray-600">
                    <li>Earn 5 points for every debit card swipe over $3</li>
                    <li>Earn 10 points for using direct deposit</li>
                    <li>Earn 25 points per month for each loan in good standing when you have a checking account</li>
                    <li>Earn 10 points for setting up at least one Loan AutoPay</li>
                    <li>Earn 1 point for every $1 spent with a Smart Rewards Credit Card</li>
                    <li>Earn 1 point per $1,000 for each Mortgage Loan when you have a checking account</li>
                    <li>Get a 2,500 point bonus for funding a new loan</li>
                    <li>Get a 5,000 point bonus for referring a friend and meeting the qualifications after 60 days</li>
                  </ul>

                  <h3 className="text-base font-bold leading-normal text-gray-800 mb-2">Redemption</h3>
                  <p className="text-sm mb-4 text-gray-600">You can redeem points for cash at any time by clicking the <strong>Redeem Points</strong> button above. You must have accrued at least 500 points in order to redeem.</p>

                  <h3 className="text-base font-bold leading-normal text-gray-800 mb-2">Referrals</h3>
                  <p className="text-sm mb-4 text-gray-600">Members that participate in the Referral Program and open a share and checking account at MAX Credit Union will receive 5,000 points if they meet all the Promotion Eligibility Requirements.
                  The participant must be eligible for membership and open a share savings account in order to open a checking account and participate in the promotion.
                  The promotion is only available to participants from the states of Alabama and Georgia.</p>
                  <p>
                    <a 
                      href="https://www.mymax.com/-/media/files/mymax/disclosures/max_rewards_disclosure.pdf" 
                      id="btnShowReferralDisclosures" 
                      className="color-white mt-2 inline-block w-auto bg-blue-600 border border-transparent rounded-full py-1 px-3 text-sm font-bold text-white text-center hover:bg-blue-700 hover:text-white"
                      target="_blank"
                      rel="noopener noreferral"
                    >
                        View Program Disclosures
                    </a>
                  </p>
                </div>
              <br /><br /><br />
            </div>
        </div>
    </div>
  );
}

export default Dashboard;